<span><i [ngClass]="flagIcon"></i></span>
<select class="hx-lang" [(ngModel)]="language" (ngModelChange)="onModelChanged($event)">
  <option value="ru" class="lang__link ng-option">{{'hx.lang.ru' | transloco}}</option>
  <option value="kk" class="lang__link ng-option">{{'hx.lang.kk' | transloco}}</option>
  <option value="en" class="lang__link ng-option">{{'hx.lang.en' | transloco}}</option>
</select>
